import React from "react"
import { connect } from "react-redux"
import { Row, Col, theme as themeConfig } from "antd"

import MetricsCard from "../../components/Metrics/MetricsCard"

import GraphTableCard from "../GraphTableCard"

const MetricsGraphGroup = ({
  cards = [],
  graph,
  metrics,
  graphs,
  colSpanCards = 6,
  colSpanGraph = 18,
  hLoadError,
  sLoadError,
  cLoadError
}) => {
  const { token } = themeConfig.useToken()

  const cardComponents = cards
    .map(id => metrics?.find(m => m?.id === id))
    .filter(Boolean)
    .map(item => (
      <Col xs={24} key={item.id}>
        <MetricsCard
          item={item}
          loadError={item?.apiType === "sessionData" ? sLoadError : hLoadError}
        />
      </Col>
    ))

  const getErrorForApiType = apiType => {
    switch (apiType) {
      case "sessionData":
        return sLoadError
      case "historicData":
        return hLoadError
      case "campaignsRecordsData":
        return cLoadError
      default:
        return undefined
    }
  }

  const renderGraphSection = id => {
    const selectedGraph = graphs.find(g => g.id === id)
    if (!selectedGraph) return <GraphTableCard graph={{ graphData: [] }} />

    return (
      <GraphTableCard
        graph={selectedGraph}
        loadError={getErrorForApiType(selectedGraph?.apiType)}
      />
    )
  }

  return (
    <Row gutter={12} style={{ marginTop: token.marginSM }}>
      <Col xs={24} md={colSpanCards}>
        <Row gutter={[0, 12]}>{cardComponents}</Row>
      </Col>

      <Col xs={24} md={colSpanGraph}>
        {renderGraphSection(graph)}
      </Col>
    </Row>
  )
}

const mapStateToProps = state => ({
  hLoadError: state.campaigns_analytics_details.hLoadError,
  sLoadError: state.campaigns_analytics_details.sLoadError,
  cLoadError: state.campaigns_analytics_details.cLoadError,
})

export default connect(mapStateToProps, null)(MetricsGraphGroup)
